import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "error-layout w-full max-w-lg text-center" }
const _hoisted_2 = {
  key: 0,
  class: "font-thin leading-none text-secondary-200"
}
const _hoisted_3 = { class: "text-2xl font-bold lg:text-3xl text-primary-900" }
const _hoisted_4 = { class: "mt-2 text-base leading-normal text-gray-600" }
const _hoisted_5 = {
  key: 1,
  class: "mt-20"
}
const _hoisted_6 = {
  key: 2,
  class: "mt-20"
}

import { BaseButton } from '@/lib/components/Button';
import { logoutService } from '@/services/auth';
import FloatingBrandShapesLayout from './FloatingBrandShapesLayout.vue';
import { i18n } from '@/i18n/i18n';
import { useRouter } from 'vue-router';



export default /*#__PURE__*/_defineComponent({
  props: {
  type: {
    type: String,
    default(): string {
      return i18n.global.t('platform.error.error') as string;
    }
  },
  title: {
    type: String,
    default(): string {
      return i18n.global.t('platform.error.error') as string;
    }
  },
  message: {
    type: String,
    default(): string {
      return i18n.global.t('platform.error.error-found') as string;
    }
  },
  isNoOrganisation: {
    type: Boolean,
    default: false
  }
},
  setup(__props) {

const router = useRouter();


const goBack = async () => {
  await router.back();
};

const reload = async () => {
  await router.go(0);
};

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createBlock(FloatingBrandShapesLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (!__props.isNoOrganisation)
          ? (_openBlock(), _createElementBlock("h1", _hoisted_2, _toDisplayString(__props.type), 1))
          : _createCommentVNode("", true),
        _createElementVNode("p", _hoisted_3, _toDisplayString(__props.title), 1),
        _createElementVNode("p", _hoisted_4, _toDisplayString(__props.message), 1),
        _renderSlot(_ctx.$slots, "default"),
        (!__props.isNoOrganisation)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_unref(BaseButton), {
                size: "large",
                color: "primary",
                onClick: goBack
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('platform.error.go-back')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_RouterLink, {
                to: "/",
                class: "block mt-4 text-link"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('platform.error.return-home')), 1)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (__props.isNoOrganisation)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_unref(BaseButton), {
                "left-icon": "reload",
                size: "large",
                color: "primary",
                onClick: reload
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('platform.error.try-again')), 1)
                ]),
                _: 1
              }),
              _createElementVNode("div", {
                class: "block mt-4 text-link",
                style: {"cursor":"pointer"},
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(logoutService)()))
              }, _toDisplayString(_ctx.$t('platform.error.logout')), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 3
  }))
}
}

})